module.exports = __webpack_public_path__ + "img/26.46b4c1e8.jpg";